"use strict";

module.exports = function () {
  if (!this.opts.orderBy) return;
  this.orderBy.column = this.opts.orderBy.column;
  this.orderBy.ascending = this.opts.orderBy.hasOwnProperty('ascending') ? this.opts.orderBy.ascending : true;
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/methods/init-order-by.js
// module id = 1608
// module chunks = 64